import DatePicker from './DatePicker';


export default DatePicker;
export {
	DatePicker
};